// @flow
import type { FormValue } from './form';
import type { ValidationResult } from './form';

export function isRequired(value: string): ValidationResult {
  return {
    name: 'isRequired',
    isValid: !(
      value === undefined ||
      value === null ||
      value === '' ||
      value === ' '
    ),
  };
}

export function isNumber(value: string): ValidationResult {
  let isValid = value === '';
  if (isValid) {
    return { name: 'isNumber', isValid };
  }

  const regex = /^-?[0-9 ]+$/;
  isValid = regex.test(value);

  return { name: 'isNumber', isValid };
}

export function isRequiredIf(func: (state: FormValue) => boolean) {
  return function (value: string, state: FormValue): ValidationResult {
    if (func(state)) {
      return isRequired(value);
    }
    return { name: 'isRequired', isValid: true };
  };
}

export function isCurrency(value: string): ValidationResult {
  return { name: 'isCurrency', isValid: true };
}

export function formatAsCurrency(value: string): string {
  return value;
}

export function isMonth(value: string): ValidationResult {
  return { name: 'isMonth', isValid: true };
}

export function isDay(value: string): ValidationResult {
  return { name: 'isDay', isValid: true };
}

export function isYear(value: string): ValidationResult {
  return { name: 'isYear', isValid: true };
}
